export default __webpack_public_path__ + "static/media/quotes.b79d18ed.svg";